"use strict";

/**
 * Desktop banner on the top-right side of the pornstars list
 */
;
(function () {
  // Call "onPageLoad" when page loaded and "Flix" object prepared
  document.addEventListener('flix:load', onPageLoad);

  /**
   * Check if this ad should be shown
   * @returns boolean
   */
  function isEnabled() {
    return Flix.ads.enabled
    /** Desktop only */ && FlixUtils.isDesktop()
    /** pornstars index page */ && !!document.querySelector('#pornstarsAD');
  }
  ;

  /**
   * Main logic
   */
  function onPageLoad() {
    if (!isEnabled()) {
      return;
    }
    var el = document.querySelector('#pornstarsAD');
    if (Flix.isTna()) {
      el.innerHTML = "<ins class=\"adsbyexoclick\" data-zoneid=\"4505224\" data-sub=\"".concat(Flix.ads.iid, "\"></ins>");
      var s = document.createElement('script');
      s.onload = function () {
        return (AdProvider = window.AdProvider || []).push({
          "serve": {}
        });
      };
      s.src = 'https://a.realsrv.com/ad-provider.js';
      el.appendChild(s);
    } else {
      el.innerHTML = "<ins class=\"adsbyexoclick\" data-zoneid=\"4505290\" data-sub=\"".concat(Flix.ads.iid, "\"></ins>");
      var s = document.createElement('script');
      s.onload = function () {
        return (AdProvider = window.AdProvider || []).push({
          "serve": {}
        });
      };
      s.src = 'https://a.realsrv.com/ad-provider.js';
      el.appendChild(s);
    }
  }
  ;
})();